// import React from "react";

// const FeaturedCars = () => {
//   return (
//     <section
//       className="feature-sec-1 space"
//       data-bg-src="/img/bg/feature-sec-bg-1.png"
//     >
//       <div className="container">
//         {/* Heading */}
//         <div className="row justify-content-lg-between justify-content-center align-items-center">
//           <div className="col-xxl-7 col-xl-9">
//             <div className="title-area text-center text-lg-start">
//               <h2 className="sec-title"> Urbania on Rent in Pune</h2>
//             </div>
//           </div>
//         </div>

//         {/* Featured Urbania */}
//         <div className="tab-content mt-4">
//           <div className="tab-pane fade show active">
//             <div className="row gy-30 justify-content-center">
//               {[
//                 {
//                   title: "Force Urbania 10 Seater",
//                   price: "₹6,500 / Day",
//                   img: "/images/gallery/1.jpg",
//                 },
//                 {
//                   title: "Force Urbania 13 Seater",
//                   price: "₹7,500 / Day",
//                   img: "/images/gallery/2.jpg",
//                 },
//                 {
//                   title: "Force Urbania 17 Seater",
//                   price: "₹8,500 / Day",
//                   img: "/images/gallery/3.jpg",
//                 },
//                 {
//                   title: "Luxury Force Urbania",
//                   price: "₹9,000 / Day",
//                   img: "/images/gallery/4.jpg",
//                 },
//               ].map((car, index) => (
//                 <div className="col-xl-3 col-lg-4 col-sm-6" key={index}>
//                   <div className="feature-list-1">
//                     <div className="box-icon">
//                       <img
//                         src={`${car.img}`}
//                         alt={car.title}
//                       />
                  
//                     </div>

//                     <div className="car-content">
//                       <h3 className="box-title">{car.title}</h3>

//                       <ul className="car-feature">
//                         {/* <li>10–15 Seater</li> */}
//                         <li className="divider"></li>
//                         <li>Manual</li>
//                         <li className="divider"></li>
//                         <li>Diesel</li>
//                       </ul>

//                       <div className="car-bottom text-center">
//                         <a className="th-btn sm style3" href="#">
//                           Book Now{" "}
//                           <i className="fas fa-arrow-up-right"></i>
//                         </a>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

      
//       </div>
//     </section>
//   );
// };

// export default FeaturedCars;









import React from "react";

const cars = [
  {
    title: "Force Urbania 10 Seater",
    img: "/images/gallery/1.jpg",
    tag: "Mini Urbania",
  },
  {
    title: "Force Urbania 13 Seater",
    img: "/images/gallery/103.jpg",
    // img: "/images/gallery/2.jpg",
    tag: "Popular",
  },
  {
    title: "Force Urbania 17 Seater",
    img: "/images/gallery/106.jpg",
    // img: "/images/gallery/3.jpg",
    tag: "Family Choice",
  },
  {
    title: "Luxury Force Urbania",
    // img: "/images/keyword/1.jpg",
    img: "/images/gallery/96.jpg",
    tag: "Premium",
  },
];

const FeaturedCars = () => {
  return (
    <section className="urbania-premium">
      <div className="container">
        {/* Heading */}
        <div className="urbania-header">
          <h2>Urbania on Rent in Pune</h2>
          <p>Premium Urbania Rental Services with Comfort & Style</p>
        </div>

        {/* Cards */}
        <div className="row g-4">
          {cars.map((car, index) => (
            <div className="col-xl-3 col-lg-4 col-md-6" key={index}>
              <div className="urbania-premium-card">
                <span className="urbania-tag">{car.tag}</span>

                <div className="urbania-img-wrap">
                  <img src={car.img} alt={car.title} />
                </div>

                <div className="urbania-body">
                  <h3>{car.title}</h3>

                  <div className="urbania-meta">
                    <span>Manual</span>
                    <span>Diesel</span>
                  </div>

                  <a href="/booking" className="urbania-btn">
                    Book Urbania
                    <i className="fas fa-arrow-right"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedCars;
